<app-auth-wrapper [title]="'Enter your email to reset password.'">
    <form #forgotPasswordForm="ngForm" novalidate>
        <div class="formGroup">
            <div class="label">Email</div>
            <input
                type="email"
                id="resetEmail"
                name="resetEmail"
                placeholder="example@ats.com"
                class="formControl"
                #resetEmail="ngModel"
                ngModel
                required
                email
                [ngClass]="{ invalid: forgotPasswordForm.submitted && resetEmail.invalid }"
            />
            @if (forgotPasswordForm.submitted && resetEmail.errors) {
                <div class="error">
                    @if (resetEmail.errors['email']) {
                        <div>Email is invalid</div>
                    }
                    @if (resetEmail.errors['required']) {
                        <div>Email is required</div>
                    }
                </div>
            }
        </div>
        <div class="buttonsContainer">
            <button class="primary-btn" (click)="sendPasswordResetEmail(forgotPasswordForm)">
                Send password reset link
            </button>
            <button (click)="onCancel($event)" class="secondary-btn borderless">Cancel</button>
        </div>
    </form>
</app-auth-wrapper>
